module.exports = "<button class=\"btn btn-primary btn-cta btn-round\" (click)=\"openModalNewClass()\">{{ 'class.add' | translate }}</button>\n"